const About = () => (
<main>
        <h1>About Us</h1>
        <p>Curty's Kooky was founded on a simple idea: cookies should be fun, flavorful, and unforgettable. From our signature chocolate chunk to experimental seasonal bakes, every batch is made with love and a bit of kookiness.</p>
</main>
);

export default About;